import { format } from 'date-fns';

import getUserRole from 'utils/jwt/getUserRole';
import { ROLES } from 'config';
import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/voucherOrder',
};

const role = getUserRole();

export const getColumns = ({ viewOrder }) => [
  { id: 'status', label: 'Status', align: 'left', disableSort: true },
  { id: 'voucherNumber', label: 'Voucher Nr', align: 'center', disableSort: true },
  { id: 'region', label: 'Region', align: 'center', disableSort: true, disable: role === ROLES.VENDOR_ADMIN },
  { id: 'vendorName', label: 'Vendor', align: 'center', disableSort: true },
  {
    id: 'dateBought',
    label: 'Date Bought',
    customValue: (val) => (val.dateBought ? format(new Date(val.dateBought), 'E, dd MMM yyyy') : null),
    align: 'center',
    nameForSort: 'vch.purchased_date',
  },
  {
    id: 'dateClaimed',
    label: 'Date Claimed',
    customValue: (val) => (val.dateClaimed ? format(new Date(val.dateClaimed), 'E, dd MMM yyyy') : null),
    align: 'center',
    disableSort: true,
  },
  { id: 'clientName', label: 'Client', align: 'center', disableSort: true },
  { id: 'clientContact', label: 'Contact Nr', align: 'center', disableSort: true },
  { id: 'clientEmail', label: 'Client Email', align: 'center', disableSort: true },
  {
    id: 'more-menu',
    type: 'menu',
    items: [{ id: 1, name: 'Voucher View', action: viewOrder, icon: 'eva:edit-fill' }],
    disableSort: true,
  },
];

export const getFilters = ({ searchBy, status, dateRange, vendorId, options, region }) => {
  const filtersForVendorAdmin = [
    {
      id: 'name',
      type: 'search',
      placeholder: 'Search by voucher nr...',
      action: searchBy.change,
    },
    {
      id: 'dateRange',
      variant: 'date',
      type: 'dateRange',
      value: dateRange.value,
      action: dateRange.change,
    },
    {
      id: 'status',
      type: 'select',
      label: 'Status',
      value: status.value,
      action: status.change,
      items: options?.statuses?.length ? ['all', ...options.statuses] : ['all'],
    },
  ];

  const filtersForLords = [
    ...filtersForVendorAdmin,
    {
      id: 'regions',
      type: 'select',
      label: 'Region',
      value: checkAccess([2]) ? getFranchiseRegion() : region.value,
      action: region.change,
      items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
      disabledEdit: checkAccess([2]),
    },
    {
      id: 'vendor',
      type: 'select',
      label: 'Vendor',
      disabled: !options?.vendors,
      value: vendorId.value,
      action: vendorId.change,
      items: options?.vendors?.length ? ['all', ...options.vendors] : ['all'],
    },
  ];

  if (checkAccess([0, 1, 2])) {
    return filtersForLords;
  }

  return filtersForVendorAdmin;
};
